import { render, staticRenderFns } from "./ModalNotifications.vue?vue&type=template&id=5d39f544&lang=pug&"
import script from "./ModalNotifications.vue?vue&type=script&lang=js&"
export * from "./ModalNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotifications.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports